/**
 * Supported Payment Methods.
 *
 * Case of payment methods is important during comparisons (unfortunately). Back-end DTOs will typically
 * return Payment Methods in the following cases:
 * - PAYMENT_METHOD_ACH = "ACH"
 * - PAYMENT_METHOD_CHECK = "Check"
 * - PAYMENT_METHOD_WIRE = "Wire"
 *
 * @see https://github.com/junipersquare/main/blob/8ad2e98/jsq/lib/__init__.py#L1578-L1580
 */
export enum PaymentMethod {
  ACH = "ACH",
  Check = "Check",
  Wire = "Wire",
}

export enum JobType {
  PortalInvitation = 91,
}

/**
 * JSQ Object Types used across the application.
 * These correspond to the backend ObjectType enum values.
 */
export enum JsqObjectTypeValues {
  Contact = "contact",
  Position = "position",
  ContactInvestments = "contact_investments",
}
